import React from "react";
import { Nav } from "shards-react";
import PropTypes from "prop-types";
import SidebarNavItem from "./SidebarNavItem";
import { Store } from "../../../flux";

class SidebarNavItems extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      navItems: Store.getSidebarItems(),
    };

    this.onChange = this.onChange.bind(this);
  }

  componentWillMount() {
    Store.addChangeListener(this.onChange);
  }

  componentWillUnmount() {
    Store.removeChangeListener(this.onChange);
  }

  onChange() {
    this.setState({
      ...this.state,
      navItems: Store.getSidebarItems()
    });
  }
  render() {
    const { navItems: items } = this.state;
    return (
      <div className="nav-wrapper">
        <Nav className="nav--no-borders flex-column">
        {this.props.currentUser ? (
          <>
          {items.map((item, idx) => (
            item.role === this.props.currentUser.role ? <SidebarNavItem key={idx} item={item} /> : null
          ))}
          </>
          ): 'loading...'}
        </Nav>
      </div>
    )
  }
}

SidebarNavItems.propTypes = {
  /**
   * The item object.
   */
  currentUser: PropTypes.object
};
export default SidebarNavItems;
